// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v1/mcp.proto (package infinigence.infini.agentplatform.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Param } from "./param_pb.js";
import { file_agentplatform_v1_param } from "./param_pb.js";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v1/mcp.proto.
 */
export const file_agentplatform_v1_mcp: GenFile = /*@__PURE__*/
  fileDesc("ChphZ2VudHBsYXRmb3JtL3YxL21jcC5wcm90bxIjaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEi2Q0KA01DUBIuCgJpZBgBIAEoCUIiukcfOg4SDCJtY3AtYWJjMTIzIpICDOi1hOa6kOe8luWPtxI7CgRuYW1lGAMgASgJQi26Ryo6FRITIuaIkeeahCBNQ1Ag5pyN5YqhIpICEE1DUCDmnI3liqHlkI3np7ASUQoLZGVzY3JpcHRpb24YBCABKAlCPLpHOTokEiIi5o+Q5L6b5paH5Lu25pON5L2c55qEIE1DUCDmnI3liqEikgIQTUNQIOacjeWKoeaPj+i/sBI9Cgl0ZW5hbnRfaWQYBSABKAlCH7pHHDoOEgwidGVuYW50LTAwMSKSAgnnp5/miLcgSURSCXRlbmFudF9pZBI3Cgd1c2VyX2lkGAYgASgJQh26Rxo6DBIKInVzZXItMDAxIpICCeeUqOaItyBJRFIHdXNlcl9pZBJOCghjbGFzc19pZBgHIAEoCUIyukcvOhMSESJtY3BjbGFzcy1hYmMxMjMikgIX5omA5bGeIE1DUCDmnI3liqHnsbsgSURSCGNsYXNzX2lkEqIBCgxjbGFzc19wYXJhbXMYCCADKAsyOS5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5NQ1AuQ2xhc3NQYXJhbXNFbnRyeUJDukdAkgI95L2/55SoIE1DUCDmnI3liqHnsbvliJvlu7ogTUNQIOacjeWKoeaXtuS8oOWFpeeahOWPguaVsOWIl+ihqFIMY2xhc3NfcGFyYW1zEl4KCnNlcnZlcl91cmwYCSABKAlCPrpHOzofEh0iaHR0cHM6Ly9tY3AuZXhhbXBsZS5jb20vc3NlIpICF01DUCBTZXJ2ZXIg6L+e5o6l5Zyw5Z2AUgpzZXJ2ZXJfdXJsErUBCgl0cmFuc3BvcnQYCiABKA4yMS5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5NQ1BUcmFuc3BvcnRCb7pHbDohEh8iTUNQX1RSQU5TUE9SVF9TVFJFQU1BQkxFX0hUVFAikgJG5Lyg6L6T5pa55byP77yI5bmz5Y+w6K6w5b2V5LiO5o6i5rS755So77yM5LiN5LiL5Y+R5YiwIHZpYmUgVG9vbGtpdO+8iRKQAQoHaGVhZGVycxgLIAMoCzI1LmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLk1DUC5IZWFkZXJzRW50cnlCSLpHRZICQumJtOadg+WktO+8iOS4gOacn+aYjuaWh+WtmOWCqO+8jOWQqyBBdXRob3JpemF0aW9uIOetieaVj+aEn+WAvO+8iRJYCgthbGxvd190b29scxgMIAMoCUI2ukczOg0SCyJyZWFkX2ZpbGUikgIh5bel5YW355m95ZCN5Y2V77yM56m66KGo56S65YWo5byAUgthbGxvd190b29scxJGCgpkZW55X3Rvb2xzGA0gAygJQia6RyM6DxINImRlbGV0ZV9maWxlIpICD+W3peWFt+m7keWQjeWNlVIKZGVueV90b29scxJtCg90aW1lb3V0X3NlY29uZHMYDiABKAVCQ7pHQDoEEgIzMJICN+i/nuaOpei2heaXtu+8iOenku+8ie+8jDw9MCDooajnpLrkvb/nlKjlubPlj7Dpu5jorqTlgLxSD3RpbWVvdXRfc2Vjb25kcxKUAQoPc2tpcF90bHNfdmVyaWZ5GA8gASgIQmq6R2c6BxIFZmFsc2WSAlvmmK/lkKbot7Pov4cgVExTIOivgeS5puagoemqjO+8jHRydWUg5pe25qGG5p625Zyo6L+e5o6l6K+lIE1DUCBzZXJ2ZXIg5pe25LiN5qCh6aqM6K+B5Lmm6ZO+Ug9za2lwX3Rsc192ZXJpZnkSSAoKY3JlYXRlZF9hdBgQIAEoA0IoukclOgwSCjE3MDAwMDAwMDCSAgzliJvlu7rml7bpl7SaAgVpbnQ2NFIKY3JlYXRlZF9hdBJICgp1cGRhdGVkX2F0GBEgASgDQii6RyU6DBIKMTcwMDAwMDAwMJICDOabtOaWsOaXtumXtJoCBWludDY0Ugp1cGRhdGVkX2F0EkgKCmRlbGV0ZWRfYXQYEiABKANCKLpHJToMEgoxNzAwMDAwMDAwkgIM5Yig6Zmk5pe26Ze0mgIFaW50NjRSCmRlbGV0ZWRfYXQaMgoQQ2xhc3NQYXJhbXNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBGi4KDEhlYWRlcnNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBOhC6Rw2SAgpNQ1Ag5pyN5YqhIt0BCgdNQ1BUb29sEi8KBG5hbWUYASABKAlCIbpHHjoNEgsicmVhZF9maWxlIpICDOW3peWFt+WQjeensBJFCgtkZXNjcmlwdGlvbhgCIAEoCUIwukctOhwSGiLor7vlj5bmjIflrprmlofku7blhoXlrrkikgIM5bel5YW35o+P6L+wEkgKDGlucHV0X3NjaGVtYRgDIAEoCUIkukchkgIe5bel5YW36L6T5YWl5Y+C5pWwIEpTT04gU2NoZW1hUgxpbnB1dF9zY2hlbWE6ELpHDZICCk1DUCDlt6Xlhbci5wUKCE1DUENsYXNzEjMKAmlkGAEgASgJQie6RyQ6ExIRIm1jcGNsYXNzLWFiYzEyMyKSAgzotYTmupDnvJblj7cSQQoEbmFtZRgDIAEoCUIzukcwOhgSFiLmiJHnmoQgTUNQIOacjeWKoeexuyKSAhNNQ1Ag5pyN5Yqh57G75ZCN56ewElEKC2Rlc2NyaXB0aW9uGAQgASgJQjy6Rzk6IRIfIuaWh+S7tuaTjeS9nCBNQ1Ag5pyN5Yqh5qih5p2/IpICE01DUCDmnI3liqHnsbvmj4/ov7ASPQoJdGVuYW50X2lkGAUgASgJQh+6Rxw6DhIMInRlbmFudC0wMDEikgIJ56ef5oi3IElEUgl0ZW5hbnRfaWQSNwoHdXNlcl9pZBgGIAEoCUIdukcaOgwSCiJ1c2VyLTAwMSKSAgnnlKjmiLcgSURSB3VzZXJfaWQSTgoIdGVtcGxhdGUYCiABKAsyKC5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5NQ1BCErpHD5ICDE1DUCBUZW1wbGF0ZRJVCgZwYXJhbXMYCyADKAsyKi5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5QYXJhbUIZukcWkgITTUNQIOacjeWKoeexu+WPguaVsBJICgpjcmVhdGVkX2F0GAwgASgDQii6RyU6DBIKMTcwMDAwMDAwMJICDOWIm+W7uuaXtumXtJoCBWludDY0UgpjcmVhdGVkX2F0EkgKCnVwZGF0ZWRfYXQYDSABKANCKLpHJToMEgoxNzAwMDAwMDAwkgIM5pu05paw5pe26Ze0mgIFaW50NjRSCnVwZGF0ZWRfYXQSSAoKZGVsZXRlZF9hdBgOIAEoA0IoukclOgwSCjE3MDAwMDAwMDCSAgzliKDpmaTml7bpl7SaAgVpbnQ2NFIKZGVsZXRlZF9hdDoTukcQkgINTUNQIOacjeWKoeexuyqAAQoMTUNQVHJhbnNwb3J0Eh0KGU1DUF9UUkFOU1BPUlRfVU5TUEVDSUZJRUQQABIVChFNQ1BfVFJBTlNQT1JUX1NTRRABEiEKHU1DUF9UUkFOU1BPUlRfU1RSRUFNQUJMRV9IVFRQEAISFwoTTUNQX1RSQU5TUE9SVF9TVERJTxADQklaR2dpdGxhYi5pbmZpbmktYWkuY29tL21pemFyL2luZmluaWFpLWFnZW50aWMtaW5mcmEvY29tbW9uL2dycGNhcGlzL3YxO3YxYgZwcm90bzM", [file_agentplatform_v1_param, file_gnostic_openapi_v3_annotations]);

/**
 * 定义 MCP 服务
 *
 * @generated from message infinigence.infini.agentplatform.v1.MCP
 */
export type MCP = Message<"infinigence.infini.agentplatform.v1.MCP"> & {
  /**
   * 资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * MCP 服务名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * MCP 服务描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 6 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 所属 MCP 服务类 ID
   * @gotags: json:"class_id,omitempty"
   *
   * @generated from field: string class_id = 7 [json_name = "class_id"];
   */
  classId: string;

  /**
   * 使用 MCP 服务类创建 MCP 服务时传入的参数列表
   * @gotags: json:"class_params,omitempty"
   *
   * @generated from field: map<string, string> class_params = 8 [json_name = "class_params"];
   */
  classParams: { [key: string]: string };

  /**
   * MCP Server 连接地址
   * @gotags: json:"server_url,omitempty"
   *
   * @generated from field: string server_url = 9 [json_name = "server_url"];
   */
  serverUrl: string;

  /**
   * 传输方式（平台记录与探活用，不下发到 vibe Toolkit）
   * @gotags: json:"transport,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCPTransport transport = 10;
   */
  transport: MCPTransport;

  /**
   * 鉴权头（一期明文存储，含 Authorization 等敏感值）
   * @gotags: json:"headers,omitempty"
   *
   * @generated from field: map<string, string> headers = 11;
   */
  headers: { [key: string]: string };

  /**
   * 工具白名单，空表示全开
   * @gotags: json:"allow_tools,omitempty"
   *
   * @generated from field: repeated string allow_tools = 12 [json_name = "allow_tools"];
   */
  allowTools: string[];

  /**
   * 工具黑名单
   * @gotags: json:"deny_tools,omitempty"
   *
   * @generated from field: repeated string deny_tools = 13 [json_name = "deny_tools"];
   */
  denyTools: string[];

  /**
   * 连接超时（秒），<=0 表示使用平台默认值
   * @gotags: json:"timeout_seconds,omitempty"
   *
   * @generated from field: int32 timeout_seconds = 14 [json_name = "timeout_seconds"];
   */
  timeoutSeconds: number;

  /**
   * 是否跳过 TLS 证书校验，true 时框架在连接该 MCP server 时不校验证书链
   * @gotags: json:"skip_tls_verify,omitempty"
   *
   * @generated from field: bool skip_tls_verify = 15 [json_name = "skip_tls_verify"];
   */
  skipTlsVerify: boolean;

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 16 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 17 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 18 [json_name = "deleted_at"];
   */
  deletedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.MCP.
 * Use `create(MCPSchema)` to create a new message.
 */
export const MCPSchema: GenMessage<MCP> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_mcp, 0);

/**
 * MCP 工具
 *
 * @generated from message infinigence.infini.agentplatform.v1.MCPTool
 */
export type MCPTool = Message<"infinigence.infini.agentplatform.v1.MCPTool"> & {
  /**
   * 工具名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 工具描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * 工具输入参数 JSON Schema
   * @gotags: json:"input_schema,omitempty"
   *
   * @generated from field: string input_schema = 3 [json_name = "input_schema"];
   */
  inputSchema: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.MCPTool.
 * Use `create(MCPToolSchema)` to create a new message.
 */
export const MCPToolSchema: GenMessage<MCPTool> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_mcp, 1);

/**
 * 定义 MCP 服务类
 *
 * @generated from message infinigence.infini.agentplatform.v1.MCPClass
 */
export type MCPClass = Message<"infinigence.infini.agentplatform.v1.MCPClass"> & {
  /**
   * 资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * MCP 服务类名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * MCP 服务类描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 6 [json_name = "user_id"];
   */
  userId: string;

  /**
   * MCP Template
   * @gotags: json:"template,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.MCP template = 10;
   */
  template?: MCP | undefined;

  /**
   * MCP 服务类参数
   * @gotags: json:"params,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Param params = 11;
   */
  params: Param[];

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 12 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 13 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 14 [json_name = "deleted_at"];
   */
  deletedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.MCPClass.
 * Use `create(MCPClassSchema)` to create a new message.
 */
export const MCPClassSchema: GenMessage<MCPClass> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_mcp, 2);

/**
 * MCP 传输方式
 *
 * @generated from enum infinigence.infini.agentplatform.v1.MCPTransport
 */
export enum MCPTransport {
  /**
   * @generated from enum value: MCP_TRANSPORT_UNSPECIFIED = 0;
   */
  MCP_TRANSPORT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MCP_TRANSPORT_SSE = 1;
   */
  MCP_TRANSPORT_SSE = 1,

  /**
   * @generated from enum value: MCP_TRANSPORT_STREAMABLE_HTTP = 2;
   */
  MCP_TRANSPORT_STREAMABLE_HTTP = 2,

  /**
   * @generated from enum value: MCP_TRANSPORT_STDIO = 3;
   */
  MCP_TRANSPORT_STDIO = 3,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.MCPTransport.
 */
export const MCPTransportSchema: GenEnum<MCPTransport> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_mcp, 0);

